import {getRecentDisplayedNumber, getNearbySearchesNumber} from './analytics';

export function isGoogle(selectionType) {
    return selectionType === 'google';
}

function getSelectionType(poweredByGoogle) {
    return poweredByGoogle ? 'google' : 'standard';
}

function getGoogleSelectionPlaceIdObject(selectionType, uuid) {
    return isGoogle(selectionType) ? {googleselectionplaceid: uuid} : {};
}

function getResultsUuidObject(resultsUuid) {
    return resultsUuid ? {resultsuuid: resultsUuid} : {};
}

function getGeoSystemType(result) {
    if (result.google) {
        return 'GOOGLE';
    }
    return 'GAIA';
}

function buildSuggestionList(results) {
    return results.map((result) => {
        const sourceSystem = getGeoSystemType(result);
        const suggestion = {
            sourceSystem,
            id: result.gaiaId || result.uuid,
            type: result.type
        };
        if (result.recentlyviewed) {
            suggestion.reason = 'rcntsrch';
        }
        return suggestion;
    });
}

function setUserInput(prevSearch, userInput) {
    return prevSearch === userInput ? '' : userInput;
}

export function buildFocusEventPayload({prefilledValue, results}) {
    return {
        prevsearch: prefilledValue,
        recentsdisplayed: results ? getRecentDisplayedNumber(results) : 0,
        nearbydisplayed: results ? getNearbySearchesNumber(results) : 0
    };
}

export function getSelectedResultType(destination) {
    if (destination && destination.recentlyviewed === true) {
        return 'recent_selected';
    } else if (destination && destination.matchType === 'RECO') {
        return 'nearby_selected';
    }

    return 'standard';
}

// eslint-disable-next-line complexity
export function buildSelectionEventPayload({
    destination,
    results,
    userInput,
    focusTime,
    isSelectByBlur,
    analytics: {
        backspaceCounter,
        noSelectionCounter,
        prevSearch,
        resultsUuid,
        selectionDepth
    }
}) {
    const selectionType = getSelectionType(destination.poweredByGoogle);
    const resultsUuidObject = getResultsUuidObject(resultsUuid);
    const googleSelectionPlaceIdObject = getGoogleSelectionPlaceIdObject(
        selectionType,
        destination.uuid
    );
    const sourcesystem = getGeoSystemType(destination);

    let recentsDisplayed = 0;
    let totalResults = 0;
    let suggestionlist = [];

    if (results) {
        recentsDisplayed = getRecentDisplayedNumber(results);
        if (!isGoogle(selectionType)) {
            totalResults = results.length - recentsDisplayed;
        }
        suggestionlist = buildSuggestionList(results);
    }

    const resultType = getSelectedResultType(destination);

    userInput = setUserInput(prevSearch, userInput);
    return {
        character_typed: (userInput ? userInput.length : 0).toString(),
        userinput: userInput,
        event_action: resultType,
        totalbackspaces: backspaceCounter,
        totalnoselections: noSelectionCounter,
        totalresults: totalResults,
        selectiondepth: destination.suggestionDepth || selectionDepth,
        selectiontype: selectionType,
        recentsdisplayed: recentsDisplayed,
        prevsearch: prevSearch,
        geouuid: destination.uuid,
        geotypes: destination.type,
        geoname: destination.term,
        matchtype: destination.matchType,
        suggestionlist,
        sourcesystem,
        searchdestinationid: destination.gaiaId || destination.uuid,
        is_typeahead_selection: String(!isSelectByBlur),
        time_from_focus_to_blur: (Date.now() - focusTime).toString(),
        ...resultsUuidObject,
        ...googleSelectionPlaceIdObject
    };
}
